<template>
    <bootstrap-box>
        <template v-slot:header>
            <h3 class="box-title">{{title}}</h3>
        </template>
        <template v-slot:body>
            <newsroom-item-editor
                ref="editor"
                    
                :date.sync="model.dateValue"
                :title.sync="model.title"
                :content.sync="model.content"
            />

            <div class="form-group">
                <div class="row">
                    <div class="col-12">
                        <slot name="action-buttons" v-bind:isValid="formIsValid" v-bind:newsroomItem="model" />
                    </div>
                </div>
            </div>
        </template>
    </bootstrap-box>
</template>

<script>
    import dateFormattingMixin from "../../Mixins/date-formatting";

    import BootstrapBox from "../../../../Components/Util/BootstrapBox.vue";
    import NewsroomItemEditor from "./NewsroomItemEditor.vue";
    
    export default {
        components: {
            NewsroomItemEditor, 
            BootstrapBox
        },
        mixins: [dateFormattingMixin],
        created() {
            if(this.newsroomItem){
                this.model.dateValue = this.newsroomItem.dateValue;
                this.model.title = this.newsroomItem.title;
                this.model.content = this.newsroomItem.content;
                this.model.id = this.newsroomItem.id;
            }
        },
        watch: {
            model: {
                deep: true,
                handler(){
                    this.formIsValid = !this.$refs.editor.$v.$invalid;
                }
            }
        },
        data(){
            return {
                formIsValid: false,
                model: {
                    dateValue: this.formatDate(new Date()),
                    title: '',
                    content: '',
                    id: null
                }
            }
        },
        props: {
            title: String,
            
            newsroomItem: {
                type: Object,
                required: false
            }
        }
    }
</script>